module.exports = __webpack_public_path__ + "static/img/reactive_newproducts-01.6e35c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/reactive_newproducts-01.jpg
// module id = 285
// module chunks = 1